export const MARGIN = { top: 20, right: 16, bottom: 25, left: 16 };

export const CHART_SIZE = { width: 240, height: 195 };
